import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface IllustrationProps {
  type: string;
  className?: string;
}

export const Illustration: React.FC<IllustrationProps> = ({ type, className = "" }) => {
  const brand = useBrand();

  if (brand.illustrations[type]) {
    return <img src={brand.illustrations[type]} alt="" className={className} />;
  }

  const placeholders: Record<string, React.ReactNode> = {
    recentCases: (
      <svg viewBox="0 0 200 160" className={`w-48 h-40 ${className}`}>
        <rect x="50" y="20" width="100" height="80" rx="8" fill={brand.colors.primaryLight} stroke={brand.colors.primary} strokeWidth="1"/>
        <rect x="62" y="35" width="60" height="5" rx="2" fill={brand.colors.primary} opacity="0.4"/>
        <rect x="62" y="48" width="76" height="5" rx="2" fill={brand.colors.primary} opacity="0.25"/>
        <rect x="62" y="61" width="50" height="5" rx="2" fill={brand.colors.primary} opacity="0.25"/>
        <circle cx="140" cy="115" r="28" fill={brand.colors.primaryLight}/>
        <rect x="128" y="105" width="24" height="32" rx="3" fill={brand.colors.primary} opacity="0.3"/>
        <circle cx="140" cy="98" r="10" fill={brand.colors.primary} opacity="0.3"/>
      </svg>
    ),
    orders: (
      <svg viewBox="0 0 160 120" className={`w-40 h-28 ${className}`}>
        <rect x="20" y="15" width="120" height="24" rx="6" fill={brand.colors.primaryLight}/>
        <rect x="20" y="47" width="120" height="24" rx="6" fill={brand.colors.primaryLight}/>
        <rect x="20" y="79" width="120" height="24" rx="6" fill={brand.colors.primaryLight}/>
        <circle cx="38" cy="27" r="7" fill={brand.colors.primary} opacity="0.4"/>
        <circle cx="38" cy="59" r="7" fill={brand.colors.primary} opacity="0.4"/>
        <circle cx="38" cy="91" r="7" fill={brand.colors.primary} opacity="0.4"/>
      </svg>
    ),
  };

  return <>{placeholders[type] || <div className="w-32 h-32 rounded-lg" style={{ backgroundColor: brand.colors.primaryLight }} />}</>;
};
